import { MarketNotesByDate, SpecialCase } from '../types/shared/MarketSales';
import { ID_MARKET_NOTE } from '../core/constants/Sales';

export function fixMarketNotes(
  notes: MarketNotesByDate | SpecialCase | undefined,
): MarketNotesByDate {
  return notes && !(ID_MARKET_NOTE in notes) ? notes : {};
}
